import { ASSESSMENTS, CONFIGURATION, TIMING, UCRM } from 'Config/Paths';
import { CreateDueDiligenceAssessmentConfigurationRequest, DueDiligenceAssessmentConfiguration, UpdateDueDiligenceAssessmentConfigurationRequest } from 'Models/DueDiligence';
import { DueDiligenceTimeframes, UpdateDueDiligenceTimeframesRequest } from 'Models/DueDiligenceWorkflow';
import { ResponseModel } from 'Models/ResponseModel';
import { restApiDelete, restApiGet, restApiPost } from 'RestApiConnector';

import { UcrmDueDiligenceAssessmentConfigurationApi } from './UcrmDueDiligenceAssessmentConfigurationApi';

export class AWSUcrmDueDiligenceAssessmentConfigurationApi implements UcrmDueDiligenceAssessmentConfigurationApi {
    getTimeframes = (): Promise<ResponseModel<DueDiligenceTimeframes>> => {
        return restApiGet(`/${UCRM}/${CONFIGURATION}/${TIMING}`, {});
    };
    updateTimeframes = (request: UpdateDueDiligenceTimeframesRequest): Promise<ResponseModel<void>> => {
        return restApiPost(`/${UCRM}/${CONFIGURATION}/${TIMING}`, request);
    };

    getAssessmentConfiguration = (assessmentId: string): Promise<ResponseModel<DueDiligenceAssessmentConfiguration>> => {
        return restApiGet(`/${UCRM}/${CONFIGURATION}/${ASSESSMENTS}/${assessmentId}`, {});
    };
    getAllAssessmentConfigurations = (): Promise<ResponseModel<DueDiligenceAssessmentConfiguration[]>> => {
        return restApiGet(`/${UCRM}/${CONFIGURATION}/${ASSESSMENTS}`, {});
    };
    createAssessmentConfiguration = (request: CreateDueDiligenceAssessmentConfigurationRequest): Promise<ResponseModel<DueDiligenceAssessmentConfiguration>> => {
        return restApiPost(`/${UCRM}/${CONFIGURATION}/${ASSESSMENTS}`, request);
    };
    updateAssessmentConfiguration = (assessmentId: string, request: UpdateDueDiligenceAssessmentConfigurationRequest): Promise<ResponseModel<void>> => {
        return restApiPost(`/${UCRM}/${CONFIGURATION}/${ASSESSMENTS}/${assessmentId}`, request);
    };
    deleteAssessmentConfiguration = (assessmentId: string): Promise<ResponseModel<void>> => {
        return restApiDelete(`/${UCRM}/${CONFIGURATION}/${ASSESSMENTS}/${assessmentId}`);
    };
}
